import { Component, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { PatientBookingHistoryItem } from '../../core/models/patient-booking-history-item.model';
import { PatientService } from '../../core/services/patient.service';
import { NotificationService } from '../../core/services/notification.service';

@Component({
  selector: 'app-view-patient-medical-history',
  imports: [DatePipe],
  templateUrl: './view-patient-medical-history.html',
  styleUrl: './view-patient-medical-history.scss',
})
export class ViewPatientMedicalHistory implements OnInit {
  @Input() patientId?: string;
  isLoading = true;
  history: PatientBookingHistoryItem[] = [];

  constructor(
    private route: ActivatedRoute,
    private patientService: PatientService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {
    // Try to get patientId from input or route
    if (!this.patientId) {
      this.route.params.subscribe((params) => {
        this.patientId = params['id'];
        if (this.patientId) {
          this.loadHistory();
        }
      });
    } else {
      this.loadHistory();
    }
  }

  loadHistory() {
    if (!this.patientId) return;
    this.isLoading = true;
    this.patientService.getPatientBookingHistory(this.patientId).subscribe({
      next: (res) => {
        this.history = res;
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.notificationService.error('Failed to load medical history');
      },
    });
  }
}
